import React, { useState, useEffect, Fragment } from 'react';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import FormLabel from '@material-ui/core/FormLabel';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Loader from 'react-loader-spinner';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import pink from '@material-ui/core/colors/pink';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';

import axios from 'axios';
import apiUrl from '../../constants.js';
import history from '../../history';

const theme = createMuiTheme({
  palette: {
    primary: blue,
    secondary: pink,
  },
  status: {
    danger: 'orange',
  },
});

const useStyles = makeStyles ( (theme) => ({
  padding4Divs: {
    padding: '15px 0px',
  },
  padding4Labels: {
    padding: '10px 0px',
  },
  margin4Divs: {
    marginTop: '10px'
  },
  spinnerDiv: {
    height: '400px',
    width: '400px',
    textAlign: 'center',
  },
  spinner: {
    marginTop: '150px'
  },
  imgPreview: {
    maxWidth: '100px',
    margin: 'auto'
  },
  formControl: {
    margin: theme.spacing(1),
    width: '100%',
    margin: '15px 0px'
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const GeneralForm = () => {
  const classes = useStyles();

  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('user_id');

  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState({
    title: '',
    subTitle: '',
    copyright: '',
    facebook_url: '',
    instagram_url: '',
    logoImage: null,
    faviconImage: null,
    titleColor: '',
    subTitleColor: '',
    titleAlign: '',
    searchColor: '',
    backgroundColor: '',
    navbarColor: '',
    storeBoxColor: '',
    navbarTextColor: '',
    autoRotate: '',
  });

  useEffect(() => {
    getSettingsData();
  }, []);

  const [logo, setLogo] = useState({});
  const [favicon, setFavicon] = useState({});
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");

  const handleClose = (event, reason) => {
     if (reason === 'clickaway') {
       return;
     }
     setOpen(false);
  };

  const showAlert = (message, severity) => {
    setMessage(message);
    setSeverity(severity);
    setOpen(true);

    setTimeout(function(){
      setOpen(false);
    }, 3000);

  };

  const getSettingsData = () => {
    let url = apiUrl+"v1/get-settings?id_user="+userId;
    let city_prefix = process.env.REACT_APP_CITY_PREFIX;

    if(typeof city_prefix !== "undefined"){
      url = url + "&city_prefix="+city_prefix;
    }

    axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Authorization': token,
        }
      }
    )
    .then(function (response) {
      console.log(response.data);
      setSettings(response.data);
      setLoading(false);
    })
    .catch(function (error) {
      console.log(error);
      setLoading(false);
      localStorage.removeItem('user_id');
      localStorage.removeItem('token');
      history.push(process.env.REACT_APP_PREFIX_DIR+'/login');
    });
  };

  const onChangeFileHandler = (e) => {
    setSettings({
      ...settings,
      [e.target.name]: URL.createObjectURL(e.target.files[0])
    });
    switch (e.target.name) {
      case "logoImage":
        setLogo({ logoInfo: e.target.files[0] });
        break;
      case "faviconImage":
        setFavicon({ faviconInfo: e.target.files[0] });
        break;
    }
  }

  const handleChange = e => {
    setSettings({
      ...settings,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    let url = apiUrl+"v1/update-settings";
    let data = new FormData();

    data.append("id_user", userId);

    for ( var key in settings ) {
      data.append(key, settings[key]);
    }

    if(typeof logo.logoInfo !== "undefined"){
      data.append(
        "logoImage",
        logo.logoInfo,
        logo.logoInfo.name
      );
    }

    if(typeof favicon.faviconInfo !== "undefined"){
      data.append(
        "faviconImage",
        favicon.faviconInfo,
        favicon.faviconInfo.name
      );
    }

    let city_prefix = process.env.REACT_APP_CITY_PREFIX;

    if(typeof city_prefix !== "undefined"){
      data.append("city_prefix", city_prefix);
    }

    axios.post(url, data, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Authorization': token,
        }
      }
    )
    .then(function (response) {
      console.log(response);
      showAlert("LOS DATOS HAN SIDO ACTUALIZADOS SATISFACTORIAMENTE", "success");
      setLoading(false);
    })
    .catch(function (error) {
      console.log(error);
      showAlert("HA OCURRIDO UN ERROR AL INTENTAR ACTUALIZAR LOS DATOS, POR FAVOR INTENTE DE NUEVO MÁS TARDE", "error");
      setLoading(false);
    });
  };

  const { title, subTitle, copyright, facebook_url, instagram_url, logoImage, autoRotate, faviconImage, titleAlign, titleColor, subTitleColor, searchColor, backgroundColor, navbarColor ,storeBoxColor, navbarTextColor } = settings;

  return (
    <form onSubmit={(e) => handleSubmit(e)}>
      <Grid container spacing={1}>

        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity={severity}>
            {message}
          </Alert>
        </Snackbar>

        <Grid item xs={12} sm={12}>
         <Typography variant="h4">Información General</Typography>
        </Grid>

        { loading ?
          <Grid item xs={12} sm={12} className={classes.spinnerDiv}>
            <Loader
              type="Oval"
              color="#00BFFF"
              height={50}
              width={50}
              className={classes.spinner}
            />
          </Grid>
          :
          <Fragment>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                label="Titulo del sitio"
                name="title"
                type="text"
                value={title}
                onChange={handleChange}
                autoFocus
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                label="Sub-titulo del sitio"
                name="subTitle"
                type="text"
                value={subTitle}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                label="Color de la búsqueda (HEX)"
                name="searchColor"
                value={searchColor}
                onChange={handleChange}
                type="text"
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                label="Color del título (HEX)"
                name="titleColor"
                value={titleColor}
                onChange={handleChange}
                type="text"
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                label="Color del sub-título (HEX)"
                name="subTitleColor"
                value={subTitleColor}
                onChange={handleChange}
                type="text"
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-outlined-label">Alineación del título</InputLabel>
                  <Select
                    label="Alineación del título"
                    name="titleAlign"
                    required
                    value={titleAlign}
                    onChange={handleChange}
                  >
                    <MenuItem value={"center"}>Center</MenuItem>
                    <MenuItem value={"right"}>Right</MenuItem>
                    <MenuItem value={"left"}>Left</MenuItem>
                  </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={3}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                label="Color de fondo (HEX)"
                name="backgroundColor"
                value={backgroundColor}
                onChange={handleChange}
                type="text"
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                label="Navbar color (HEX)"
                name="navbarColor"
                value={navbarColor}
                onChange={handleChange}
                type="text"
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                label="Navbar text color (HEX)"
                name="navbarTextColor"
                value={navbarTextColor}
                onChange={handleChange}
                type="text"
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                label="Store Box text/border (HEX)"
                name="storeBoxColor"
                value={storeBoxColor}
                onChange={handleChange}
                type="text"
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-outlined-label">Rotación en Layerslide</InputLabel>
                  <Select
                    label="Rotación en Layerslide"
                    name="autoRotate"
                    required
                    value={autoRotate}
                    onChange={handleChange}
                  >
                    <MenuItem value={""}>Seleccionar</MenuItem>
                    <MenuItem value={1}>Si</MenuItem>
                    <MenuItem value={0}>No</MenuItem>
                  </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                label="Texto de Copyright"
                name="copyright"
                type="text"
                value={copyright}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Facebook URL:"
                name="facebook_url"
                type="text"
                value={facebook_url}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} sm={12}>
              <TextField
                variant="outlined"
                margin="normal"
                fullWidth
                label="Instagram URL:"
                name="instagram_url"
                type="text"
                value={instagram_url}
                onChange={handleChange}
              />
            </Grid>

            <Grid item xs={12} sm={12} >
              <Typography variant="h4" className={classes.padding4Divs}>Imagenes del sitio</Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormGroup component="fieldset">
                <FormLabel component="legend">Logo del sitio</FormLabel>

                { logoImage!==null ?
                  <div className="previewBox">
                    <a href={logoImage} target="_blank">
                      <img
                        src={logoImage}
                        className={classes.imgPreview}
                        />
                    </a>
                  </div>
                  :
                  null
                }

                <input
                   type="file"
                   name="logoImage"
                   className={classes.padding4Labels}
                   onChange={(e) => onChangeFileHandler(e)}
                   accept="image/x-png,image/gif,image/jpeg"
                   />
              </FormGroup>
            </Grid>

            <Grid item xs={12} sm={6}>
              <FormGroup component="fieldset">
                <FormLabel component="legend">Favicon del sitio</FormLabel>

                { faviconImage!==null ?
                  <div className="previewBox">
                    <a href={faviconImage} target="_blank">
                      <img
                        src={faviconImage}
                        className={classes.imgPreview}
                        />
                    </a>
                  </div>

                  :
                  null
                }

                <input
                   type="file"
                   name="faviconImage"
                   className={classes.padding4Labels}
                   onChange={(e) => onChangeFileHandler(e)}
                   accept="image/x-png,image/gif,image/jpeg"
                   />
              </FormGroup>
            </Grid>

            <Grid item xs={12} sm={12}>
              <Divider />

              <Button
                type="submit"
                variant="contained"
                color="primary"
                className={classes.margin4Divs}
              >
                Actualizar
              </Button>
            </Grid>
          </Fragment>
         }
      </Grid>
    </form>
  );

}

export default GeneralForm;
